const ContactsPage = () => {
    return <div className='filmik__develop'>Страница &laquo;Контакты&raquo; в&nbsp;разработке...</div>
};

export default ContactsPage;